import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostKundenArtCommandServiceModule } from '..';
import { PostKundenArtCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostKundenArtCommandServiceModule
  ],
  declarations: [PostKundenArtCommandComponent],
  exports: [PostKundenArtCommandComponent],

})
export class PostKundenArtCommandComponentModule { }
